// Shared behaviour for the app's overlays: the escape key closes them, and the screen
// behind stops scrolling while one is open. Without the second part a drag on the
// overlay scrolls the page underneath, which reads as the app misbehaving.

/**
 * Whether anything is open on top of the page.
 *
 * The camera needs this: a video is not an ordinary element, and browsers can paint it
 * above things that sit over it, so putting a modal in front is not enough on its own.
 *
 * Counted rather than a flag, because one overlay replaces another in the same tick.
 * With a flag the closing one could switch it off after the opening one switched it on.
 */
const openCount = () => useState('overlay-open-count', () => 0)

export const useOverlayOpen = () => {
  const count = openCount()

  return computed(() => count.value > 0)
}

export const useModalBehaviour = (close: () => void) => {
  const count = openCount()

  const onKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      close()
    }
  }

  onMounted(() => {
    document.addEventListener('keydown', onKeydown)
    document.body.style.overflow = 'hidden'
    count.value++
  })

  onUnmounted(() => {
    document.removeEventListener('keydown', onKeydown)
    document.body.style.overflow = ''
    count.value = Math.max(0, count.value - 1)
  })
}
